import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {MainLayout} from '~/layouts/main';
import {Quiz} from '~/components/Quiz';
export const meta = {
  title: 'SRP | Антипаттерны и запахи',
  description: 'Антипаттерны и запахи кода, которые мешают следовать принципу единственной ответственности'
};
const MDXLayout = ({children}) => _jsx(MainLayout, {
  meta: meta,
  children: children
});
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h1: "h1",
    h2: "h2",
    li: "li",
    p: "p",
    section: "section",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_components.section, {
    children: [_jsx(_components.h1, {
      children: "Антипаттерны и запахи"
    }), _jsx(_components.p, {
      children: "Существуют и антипаттерны, которые или сами нарушают SRP, или усложняют следование принципу."
    }), _jsxs(_components.section, {
      children: [_jsx(_components.h2, {
        children: "Божественный объект"
      }), _jsxs(_components.p, {
        children: [_jsx(_components.a, {
          href: "https://ru.wikipedia.org/wiki/%D0%91%D0%BE%D0%B6%D0%B5%D1%81%D1%82%D0%B2%D0%B5%D0%BD%D0%BD%D1%8B%D0%B9_%D0%BE%D0%B1%D1%8A%D0%B5%D0%BA%D1%82",
          children: "Божественный объект"
        }), " — это сущность, которая отвечает за слишком много."]
      }), _jsx(_components.p, {
        children: "Проблема таких объектов в том, что внутри них скапливается неоправданно большое количество данных. Со временем может случиться, что никакое действие нельзя будет сделать без участия божественного объекта."
      }), _jsx(_components.p, {
        children: "Это затрудняет рефакторинг, тестирование и внесение изолированных изменений в код."
      })]
    }), _jsxs(_components.section, {
      children: [_jsx(_components.h2, {
        children: "Синглтон"
      }), _jsxs(_components.p, {
        children: [_jsx(_components.a, {
          href: "https://ru.wikipedia.org/wiki/%D0%9E%D0%B4%D0%B8%D0%BD%D0%BE%D1%87%D0%BA%D0%B0_(%D1%88%D0%B0%D0%B1%D0%BB%D0%BE%D0%BD_%D0%BF%D1%80%D0%BE%D0%B5%D0%BA%D1%82%D0%B8%D1%80%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F)",
          children: "Синглтон"
        }), " — это паттерн, при котором в приложении существует только один экземпляр какого-то класса. Существующий синглтон гарантирует, что все новые созданные объекты будут ссылаться на него."]
      }), _jsx(_components.p, {
        children: "С точки зрения SRP это смешение ответственностей. Потому что синглтон не только выполняет свою основную функцию, но ещё и проверяет, не существует ли уже созданных экземпляров."
      }), _jsx(_components.p, {
        children: "Проблем у этого паттерна несколько:"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "он глобален — когда нарушается инкапсуляция состояния, повышается вероятность непредсказуемых нежелательных изменений;"
        }), "\n", _jsx(_components.li, {
          children: "излишне имплицитен — трудно заранее понять, как себя поведёт объект в какой-то ситуации;"
        }), "\n", _jsx(_components.li, {
          children: "трудно тестируется — глобальный объект хранит большое количество данных и может находиться в большом количестве различных состояний, из-за чего модульные тесты могут показывать непредсказуемые результаты."
        }), "\n"]
      })]
    }), _jsxs(_components.section, {
      children: [_jsx(_components.h2, {
        children: "Смешение архитектурных слоёв"
      }), _jsxs(_components.p, {
        children: [_jsx(_components.a, {
          href: "https://ru.wikipedia.org/wiki/Model-View-Controller",
          children: "Паттерн Model-View-Controller, MVC"
        }), " подразумевает три сущности: модель, представление и контроллер. Модель отвечает за хранение данных; представление — за их отображение; контроллер — за преобразование и обработку."]
      }), _jsx(_components.p, {
        children: "Смешение слоёв — это неправильное распределение или размазывание ответственностей между слоями. Оно может приводить:"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["к ", _jsx(_components.a, {
            href: "https://gunnarpeipman.com/aspnet/why-to-avoid-fat-controllers/",
            children: "разрастанию контроллера"
          }), ", что делает его код трудным для понимания;"]
        }), "\n", _jsx(_components.li, {
          children: "появлению логики внутри модели, что затрудняет переиспользование модели."
        }), "\n"]
      })]
    }), _jsxs(_components.section, {
      children: [_jsx(_components.h2, {
        children: "Материалы к разделу"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://habr.com/ru/post/330142/",
            children: "3 способа нарушить SRP"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://ru.wikipedia.org/wiki/%D0%91%D0%BE%D0%B6%D0%B5%D1%81%D1%82%D0%B2%D0%B5%D0%BD%D0%BD%D1%8B%D0%B9_%D0%BE%D0%B1%D1%8A%D0%B5%D0%BA%D1%82",
            children: "Божественный объект"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://habr.com/ru/post/147834/",
            children: "God object. Анализ сложных проектов"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://ru.wikipedia.org/wiki/%D0%9E%D0%B4%D0%B8%D0%BD%D0%BE%D1%87%D0%BA%D0%B0_(%D1%88%D0%B0%D0%B1%D0%BB%D0%BE%D0%BD_%D0%BF%D1%80%D0%BE%D0%B5%D0%BA%D1%82%D0%B8%D1%80%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F)",
            children: "Синглтон"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://ru.wikipedia.org/wiki/Model-View-Controller",
            children: "Паттерн MVC"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://gunnarpeipman.com/aspnet/why-to-avoid-fat-controllers/",
            children: "Why to avoid fat controllers"
          })
        }), "\n"]
      })]
    }), _jsxs(_components.section, {
      children: [_jsx(_components.h2, {
        children: "Вопросы"
      }), _jsx(Quiz, {
        name: "srp-anti-1"
      }), _jsx(Quiz, {
        name: "srp-anti-2"
      }), _jsx(Quiz, {
        name: "srp-anti-3"
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  return _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  });
}
